<template>
  <el-dialog title="详情" :visible.sync="detailDialogVisible" :width='detailDialogWidth'
             @close="detailClose" center top="10vh">
    <div class='detail'>
      <div v-loading='detailLoading'>
        <div class='baseInfo'>
          <div class='baseInfoTitle'>
            <div class='line' />
            <span>基础信息</span>
          </div>
          <div class='baseInfoContent'>
            <div class='baseInfoContentItem'>
              <span class='span1'>区域名称：</span>
              <span>{{ detailData.regionName}}</span>
            </div>
            <div class='baseInfoContentItem specialItem'>
                <span class='span1'>围栏名称：</span>
                <span>{{ detailData.fenceName }}</span>
              </div>
            </div>
            <div class='baseInfoContentItem specialItem'>
                <span class='span1' style="margin-left: 22px">坐标1：</span>
              <span  v-if="detailData && detailData.longLatitude">
               {{detailData.longLatitude[0]}},{{detailData.longLatitude[1]}}
              </span>
            </div>
          <div class='baseInfoContentItem specialItem'>
            <span class='span1' style="margin-left: 22px">坐标2：</span>
            <span  v-if="detailData && detailData.longLatitude">
              {{detailData.longLatitude[2]}},{{detailData.longLatitude[3]}}
            </span>
          </div>
          <div class='baseInfoContentItem specialItem'>
            <span class='span1' style="margin-left: 22px">坐标3：</span>
            <span  v-if="detailData && detailData.longLatitude">
              {{detailData.longLatitude[4]}},{{detailData.longLatitude[5]}}
            </span>
          </div>
          <div class='baseInfoContentItem specialItem'>
            <span class='span1' style="margin-left: 22px">坐标4：</span>
            <span  v-if="detailData && detailData.longLatitude">
              {{detailData.longLatitude[0]}},{{detailData.longLatitude[1]}}
            </span>
          </div>
          </div>
    </div>
  </div>
  </el-dialog>
</template>
<script>
import {getPageId} from "@/service/DevOps";

export default {
  data() {
    return {
      detailDialogVisible: false,
      detailDialogWidth: '500px',
      detailLoading: false,
      detailData: {},
      regionName:'',
    }
  },
  methods: {
    detailOpen(id){
      this.detailDialogVisible = true
      this.getPageId(id)
    },
    async getPageId(id) {
      const {
        status,
        message,
        data,
      } = await getPageId({
        id,
      });
      if (status !== 0) return this.$message.warning(message);
      this.detailData = data;
      this.detailData.longLatitude = JSON.parse(this.detailData.longLatitude);
      this.detailData.longLatitude  = this.detailData.longLatitude .map(obj => `${obj.lng},${obj.lat}`).join(',');
      this.detailData.longLatitude = this.detailData.longLatitude.split(',');
      this.total = data.total;
    },
    detailClose() {
      this.detailDialogVisible = false;
    },
  }
}
</script>
<style lang='scss' scoped>
.baseInfo {
  display: flex;
  flex-direction: column;

  &Title {
    display: flex;
    align-items: flex-end;

    p {
      font-weight: 700;
      font-size: 14px;
      color: rgba(51, 136, 255, 1);
      margin-left: 10px;
    }
  }

  &Content {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px 23px 0 23px;

    &Item {
      margin-bottom: 20px;

      .imgContainer {
        display: flex;
        align-items: center;
      }

      .addressItem {
        font-size: 12px;
        color: rgba(153, 153, 153, 1);
        margin-bottom: 10px;
        margin-left: 70px;
      }

      .span1 {
        font-weight: 700;
      }

      span {
        font-size: 14px;
      }

      .specialOne {
        width: 50%;
      }
    }

    .specialItem {
      display: flex;
    }
  }
}
</style>
